import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ModalCountService {
  // this is used to prevent popups appearing with lower z-index then the modal
  modalsCount$$ = signal(0);
}
